import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectActiveFlexibility } from '../../redux/selectors/client.selectors'
import { PriceComponentsCard } from './components/priceComponentsCard/priceComponentsCard'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router'
import { GlobalNotification } from '../../model'

interface PriceComponentEditPageProps {}

export const PriceComponentsPage: React.FC<PriceComponentEditPageProps> = () => {
  const [t] = useTranslation(['globalerisLibrary', 'priceComponent'])
  const history = useHistory()
  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )

  const flexibilityData = useSelector(selectActiveFlexibility)

  return (
    <Page notification={globalNotification}>
      <PageHeader
        title={t('priceComponent:titleEdit', {
          flexibilityDescription: flexibilityData?.description
        })}
      >
        <Button color="primary" onClick={() => history.goBack()}>
          {t('priceComponent:mainActions.back')}
        </Button>
      </PageHeader>
      <PriceComponentsCard flexibilityId={flexibilityData?.id} onRetry={() => {}} />
    </Page>
  )
}
